import company from 'app/entities/company/company.reducer';
import branchMaster from 'app/entities/branch-master/branch-master.reducer';
import facilityWarehouse from 'app/entities/facility-warehouse/facility-warehouse.reducer';
import receipt from 'app/entities/receipt/receipt.reducer';
import artikeltexteDID from 'app/entities/artikeltexte-did/artikeltexte-did.reducer';
import dataIdentifierSSC from 'app/entities/data-identifier-ssc/data-identifier-ssc.reducer';
import deployment from 'app/entities/deployment/deployment.reducer';
import transportOrder from 'app/entities/transport-order/transport-order.reducer';
import vehicle from 'app/entities/vehicle/vehicle.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const entitiesReducers = {
  company,
  branchMaster,
  facilityWarehouse,
  receipt,
  artikeltexteDID,
  dataIdentifierSSC,
  deployment,
  transportOrder,
  vehicle,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
};

export default entitiesReducers;
